module.exports = __webpack_public_path__ + "img/img1.838bc30d.jpg";